var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCaretLeft = function SvgCaretLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 17,
    fill: "none",
    viewBox: "0 0 10 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M8 15 2.12 8.648A.45.45 0 0 1 2 8.334a.48.48 0 0 1 .12-.314L8 1.667"
  })));
};
export { SvgCaretLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxMCAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMTUuMDAwM0wyLjEyMDUzIDguNjQ3NzNDMi4wODIzMiA4LjYwNjUxIDIuMDUyMDEgOC41NTc1NSAyLjAzMTMyIDguNTAzNjZDMi4wMTA2NCA4LjQ0OTc3IDIgOC4zOTIgMiA4LjMzMzY2QzIgOC4yNzUzMiAyLjAxMDY0IDguMjE3NTUgMi4wMzEzMiA4LjE2MzY2QzIuMDUyMDEgOC4xMDk3NiAyLjA4MjMyIDguMDYwODEgMi4xMjA1MyA4LjAxOTU4TDggMS42NjY5OSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";